const pillars = [
  {
    icon: 'ri-user-heart-line',
    label: '実体験',
    title: '実際に作った記録だけを書く',
    description: '試していないことは書かない。詰まったこと、失敗したこと、やり直したことも含めて残す。',
  },
  {
    icon: 'ri-repeat-line',
    label: '再現性',
    title: '「自分でもできる」と思える形に',
    description: '「なんかすごそう」で終わらせない。手順・判断・理由を整理して、読んだ人が試せる形にする。',
  },
  {
    icon: 'ri-file-list-2-line',
    label: '仕様化',
    title: '再利用できる形に整理する',
    description: '一度やったことを次に活かせるよう、プロセスをテンプレートや仕様書の形に落とし込む。',
  },
];

export function MissionSection() {
  return (
    <section className="py-14 sm:py-20 bg-[#FDFAF6]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">

        {/* Section header */}
        <div className="mb-8 sm:mb-10">
          <p
            className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-2"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            About This Site
          </p>
          <h2
            className="text-xl sm:text-2xl font-bold text-[#2C2416]"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            このサイトの考え方
          </h2>
        </div>

        {/* Lead text */}
        <p
          className="text-sm sm:text-base text-[#4A3F35] leading-relaxed mb-10 sm:mb-12 max-w-xl border-l-2 border-[#5B7B6F]/40 pl-4"
          style={{ fontFamily: "'Noto Serif JP', serif" }}
        >
          AIを紹介して終わる場所ではありません。<br />
          実際に使って何を作れたか、どこで詰まり、どう直したかまでを残す——<br />
          それがこのサイトの役割です。
        </p>

        {/* Pillars */}
        <div className="space-y-0">
          {pillars.map((pillar, index) => (
            <div key={pillar.label}>
              <div className="flex items-start gap-5 py-6">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-[#F0EBE3] rounded-md">
                  <i className={`${pillar.icon} text-base text-[#5B7B6F]`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span
                      className="text-xs font-semibold text-[#5B7B6F] tracking-wide"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {pillar.label}
                    </span>
                  </div>
                  <h3
                    className="text-base font-bold text-[#2C2416] mb-1.5"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}
                  >
                    {pillar.title}
                  </h3>
                  <p
                    className="text-sm text-[#7A6E62] leading-relaxed"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {pillar.description}
                  </p>
                </div>
              </div>
              {index < pillars.length - 1 && (
                <div className="border-t border-[#EDE7DF]"></div>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
